import _ from 'lodash-es';
import { createShortUrl, getShortUrlParse } from '@opm/services';
import { history, useLocation } from 'umi';
import { useEffect, useState } from 'react';
import { createShortId } from '@opm/components/FilterCommon/utils';

export async function setShortUrl(filter: any) {
  const { shortId, urlParams, pathname, params } = createShortId(filter);
  if (!shortId) return;

  try {
    await createShortUrl({ short_url: shortId, params });
    window.history.replaceState(null, '', `${pathname}?${urlParams}`);
  } catch (error) {
    console.error('setShortUrl failed:', error);
  }
}

export async function goToDetailsPage({
  filter,
  extraFilter = {},
  navigateUrl = '/details',
  saveShort = true,
  replace = false,
}: {
  filter: Record<string, any>;
  extraFilter?: Record<string, any> | string;
  navigateUrl?: string;
  saveShort?: boolean;
  replace?: boolean;
}) {
  try {
    // merge filters, support string shorthand
    const mergedFilter = {
      ...filter,
      ...(typeof extraFilter === 'string'
        ? { hashtag: extraFilter }
        : extraFilter),
    };

    const { shortId, urlParams, params } = createShortId(mergedFilter);
    if (!shortId) return;

    if (saveShort) {
      await createShortUrl({ short_url: shortId, params });
    }

    const fullUrl = `${navigateUrl}?${urlParams}`;
    history[replace ? 'replace' : 'push'](fullUrl);
  } catch (error) {
    console.error('goToDetailsPage failed:', error);
  }
}

export function useShortIdFromUrl() {
  const location = useLocation();

  // Get query params from current URL
  const searchParams = new URLSearchParams(location.search);
  const shortId = searchParams.get('shortid');

  return shortId;
}

export function useFilterFromShortId() {
  const shortId = useShortIdFromUrl();
  const [filter, setFilter] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);

  const requestFilter = () => {
    if (!shortId) return;
    setLoading(true);
    getShortUrlParse(shortId)
      .then((data: any) => {
        setFilter(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    requestFilter();
  }, [shortId]);

  return {
    loading,
    filter,
  };
}
